<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getFlowRatePercentListHandler()" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="修改时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="getFlowRatePercentListHandler()"  icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" plain @click="chgFlowSingleVisible = true" icon="el-icon-edit">单卡修改</el-button>
                <el-button type="success" plain @click="chgFlowBatchVisible = true" icon="el-icon-edit">批量修改</el-button>
                <el-button type="primary" @click="exportInfoHandle" icon="el-icon-download">导 出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" align="center"></el-table-column>      
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <el-table-column prop="createTime" label="修改时间" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>
            <el-table-column label="可用流量比" align="center">
                <template slot-scope="scope">
                    {{ scope.row.flowRatePercent }} %
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog :append-to-body="true"  title="单卡修改" :visible.sync="chgFlowSingleVisible" width="600px" @close="cancelChgFlowSingle()" :close-on-click-modal="false">
            <el-form ref="chgFlowFormSingle" :model="chgFlowFormSingle" :rules="chgFlowFormSingleRules" label-width="120px">
                <el-form-item label="iccid：" prop="iccid">
                    <el-input v-model.trim="chgFlowFormSingle.iccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="可用流量比：" prop="flowRatePercent">
                    <el-input-number v-model.trim="chgFlowFormSingle.flowRatePercent"  :min="0" :max="100" ></el-input-number>
                    <label class='label-defined percent-label'>%</label>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="chgFlowFormSingle.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelChgFlowSingle()">取 消</el-button>
                <el-button type="primary" @click="sureChgFlowSingleHandler()">确 定</el-button>
            </div> 
        </el-dialog> 

        <el-dialog :append-to-body="true"  title="批量修改" :visible.sync="chgFlowBatchVisible" width="600px" @close="cancelChgFlowBatch()" :close-on-click-modal="false">
            <el-form ref="chgFlowBatchForm" :model="chgFlowBatchForm" :rules="chgFlowBatchFormRules" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/change/flowRatePercentList')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="chgFlowBatchForm" :on-change="handleChange" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changePkg')">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>
                <el-form-item label="可用流量比：" prop="flowRatePercent">
                    <el-input-number v-model.trim="chgFlowBatchForm.flowRatePercent"  :min="0" :max="100" ></el-input-number>
                    <label class='label-defined percent-label'>%</label>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="chgFlowBatchForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelChgFlowBatch()">取 消</el-button>
                <el-button type="primary" @click="sureChgFlowBatchHandler()">确 定</el-button>
            </div> 
        </el-dialog>           
    </div>
</template>
<script>
import {getFlowRatePercentList} from '@/api/record.js'
import {sureChgFlowRateSingle} from '@/api/sim.js'
import common from '@/utils/common.js'
import {flowStatistics, flowEveryDayDetail, flowEveryMonthDetail, flowStatisticsExport2} from '@/api/csm.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                supplierCode: '',
                basePkgGroup: '',
            },
            pkgGroup: [],
            branchSupplierOption: [],


            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            
            //批量修改
            chgFlowBatchVisible: false,
            chgFlowBatchForm: {
                flowRatePercent: '',
                remark: ''
            },

            chgFlowBatchFormRules:{

            },

            //单卡修改
            chgFlowSingleVisible: false,
            chgFlowFormSingle: {
                iccid:'',
                flowRatePercent: 0,
                remark: ''
            },
            chgFlowFormSingleRules: {
                iccid: [{required: true, message: '请输入iccid', trigger: 'blur'}],
                flowRatePercent: [{required: true, message: '请输入流量比', trigger: 'blur'}],
            }
        }
    },
    methods: {
        exportInfoHandle(){//导出excel文件
            this.$confirm("确定要导出吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.deleteSpaceKey(this.searchForm); 
                flowStatisticsExport2( this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(()=>{});
        },



        //取消单卡修改
        cancelChgFlowSingle(){
            for(let key in this.chgFlowFormSingle){
                this.chgFlowFormSingle[key] = '';
            }
            this.chgFlowSingleVisible = false; 
        },
        //取消批量修改
        cancelChgFlowBatch(){
            for(let key in this.chgFlowBatchForm){
                this.chgFlowBatchForm[key] = '';
            }
            this.chgFlowBatchVisible = false; 
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getFlowRatePercentListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getFlowRatePercentList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })      
        },
        showChgPkgGroup(){
            this.chgPkgGroupVisible = true;
            common.getPkgGroupListCom(this, 'pkgGroup');
        },
        //确定单卡修改
        sureChgFlowSingleHandler(){
            this.$refs.chgFlowFormSingle.validate(valid => {
                if(valid){

                    this.$confirm('确定要修改卡片流量比吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let params = this.chgFlowFormSingle;
                        let formData = new FormData();
                            Object.keys(params).forEach((key) => {
                            formData.append(key, params[key]);
                        });
                        sureChgFlowRateSingle(formData).then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);

                                this.cancelChgFlowSingle();//关闭弹窗
                                this.getFlowRatePercentListHandler();//刷新页面
                            }else{
                                this.$message.error(res.data.message)
                            }
                        });
                    }).catch(() => {

                    });
                }
            })
        },
        //确定批量修改
        sureChgFlowBatchHandler(){
            this.$confirm('确定要批量修改卡片流量比吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.upload.submit();
            }).catch(() => {

            });

        },

        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.chgFlowBatchForm.fields[0].clearValidate();
            }
        },        
        handleSuccess(res){
            if(res.code == 200){
                this.chgFlowBatchVisible = false;
                this.getFlowRatePercentListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },        
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getFlowRatePercentListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getFlowRatePercentListHandler();
        }  
    },
    created () {
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        this.getFlowRatePercentListHandler()
    }
}
</script>
<style lang="less" scoped>
    .percent-label{
        height: 28px;
        line-height: 28px;
        background: #fff;
        z-index: 100;
        position: absolute;
        left: 80px;
        top: 2px;
        font-size: 16px;
    }
</style>

